<div class="slider-wrapper">
    <sol-range-slider *ngIf="isTimeType && showSlider" class="slider-body w-100" name="timeRangeSlider" 
        [startPoints]="startPoints" 
        [range]="range"
        [tooltipFormatter]='timeTooltipFormatter' 
        [enableTooltipOnDrag]="true" 
        [pips]="rangePips" 
        [connect]="connect"
        [colorClasses]="colorClasses" 
        (changeEvent)="onRangeChange($event)">
    </sol-range-slider>

    <sol-range-slider *ngIf="!isTimeType && showSlider" class="slider-body w-100" name="percentAndNumberRangeSlider"
        [min]="min"
        [max]="max"
        [step]="step"
        [markerValues]="markerValues"
        [tooltipFormatter]='tooltipFormatter' 
        [enableTooltipOnDrag]="true" 
        [startPoints]="startPoints" 
        [connect]="connect"
        [colorClasses]="colorClasses"
        (changeEvent)="onRangeChange($event)">    
    </sol-range-slider>
</div>
